function key(value){return String(value??'').trim();}
function number(value){const n=Number(value);return Number.isFinite(n)?n:null;}
function stable(value){return JSON.stringify(value);}
function changed(field,source,repeat){return Object.freeze({field,source,repeat});}

function productRows(bundle={}){
  return (bundle.items||[]).filter(x=>!x.deletedAt).map(item=>Object.freeze({
    key:key(item.catalogueProductCode||item.customProductId||item.nameSnapshot||item.id),
    name:item.nameSnapshot||null,
    quantity:number(item.quantity),
    mass:number(item.mass),
    massUnit:item.massUnit||null
  })).sort((a,b)=>a.key.localeCompare(b.key));
}
function woodRows(bundle={}){
  return (bundle.woods||[]).filter(x=>!x.deletedAt).map(wood=>Object.freeze({
    key:key(wood.woodKey||wood.inventoryItemId||wood.nameSnapshot||wood.id),
    name:wood.nameSnapshot||null,
    sharePercent:number(wood.sharePercent)
  })).sort((a,b)=>a.key.localeCompare(b.key));
}
function stageRows(bundle={}){
  const targets=new Map((bundle.stageTargets||[]).map(x=>[key(x.stageId),x]));
  return (bundle.stages||[]).filter(x=>!x.deletedAt).map(stage=>{
    const target=targets.get(key(stage.id))||{};
    return Object.freeze({
      key:key(stage.typeKey||stage.nameOverride||stage.id),
      name:stage.nameOverride||stage.typeKey||null,
      sortOrder:number(stage.sortOrder),
      targetChamberCelsius:number(target.targetChamberCelsius),
      plannedDurationMinutes:number(target.plannedDurationMinutes)
    });
  }).sort((a,b)=>(a.sortOrder??0)-(b.sortOrder??0)||a.key.localeCompare(b.key));
}
function smoker(bundle={}){
  const session=bundle.session||{};
  return Object.freeze({
    id:session.smokerId||null,
    name:session.smokerSnapshot?.name||null,
    snapshot:session.smokerSnapshot||null
  });
}

export function compareRepeatToSource({source={},repeat={}}={}){
  const sourceId=source.session?.id;
  const repeatSourceId=repeat.session?.sourceSessionId;
  if(!sourceId||repeatSourceId!==sourceId)throw new TypeError('REPEAT_SOURCE_LINK_MISMATCH');

  const differences=[];
  const pairs=[
    ['smoker',smoker(source),smoker(repeat)],
    ['products',productRows(source),productRows(repeat)],
    ['woodMix',woodRows(source),woodRows(repeat)],
    ['stages',stageRows(source),stageRows(repeat)]
  ];
  for(const [field,a,b] of pairs)if(stable(a)!==stable(b))differences.push(changed(field,a,b));

  return Object.freeze({
    sourceSessionId:sourceId,
    repeatSessionId:repeat.session?.id||null,
    changed:Boolean(differences.length),
    differences:Object.freeze(differences),
    comparedFields:Object.freeze(['smoker','products','woodMix','stages'])
  });
}
